import { useIntl } from 'react-intl';
import type { MessageValue } from 'react-intl';

export const useCustomerRatingsHistogramMessages = () => {
  const { formatMessage } = useIntl();

  const getLabel = (rating: number) =>
    formatMessage<{ readonly rating: number | bigint }>(
      {
        id: 'customerRatings.histogram.label',
        defaultMessage: '{rating, plural, one {# Stern} other {# Sterne}}',
      },
      { rating },
    );

  const getLinkLabel = (rating: number, count: number) =>
    formatMessage<{ readonly count: MessageValue; readonly rating: number | bigint }>(
      {
        id: 'customerRatings.histogram.link.label',
        defaultMessage:
          'Alle Bewertungen mit {rating, plural, one {# Stern} other {# Sternen}} anzeigen ({count})',
      },
      { rating, count },
    );

  return {
    getLabel,
    getLinkLabel,
  };
};
